import { render, staticRenderFns } from "./NotificacionFormHeader.vue?vue&type=template&id=2562defa"
import script from "./NotificacionFormHeader.vue?vue&type=script&lang=js"
export * from "./NotificacionFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports